import React from "react";
import styles from "./styles.module.scss";
import { Oval } from "react-loader-spinner";
import useDomainStore from "../../stores/domain";

const Button = ({
  variant = "primary",
  children,
  onClick,
  disabled = false,
  icon,
  fullWidth = false,
  isLoading = false,
  size = "medium",
  condensedX = false,
  ...props
}) => {
  const { isKurvDomain } = useDomainStore();
  // Apply Kurv theme for primary, ghost, and secondary variants
  const getVariantClass = () => {
    if (variant === "primary" && isKurvDomain) {
      return styles.kurvPrimary;
    }
    if (variant === "ghost" && isKurvDomain) {
      return styles.kurvGhost;
    }
    if (variant === "secondary" && isKurvDomain) {
      return styles.kurvSecondary;
    }
    return styles[variant];
  };

  return (
    <button
      className={`${styles.button} ${getVariantClass()} ${disabled ? styles.disabled : ""} ${icon ? styles.withIcon : ""} ${fullWidth ? styles.fullWidth : ""} ${styles[size]} ${condensedX ? styles.condensedX : ""}`}
      onClick={!disabled && !isLoading ? onClick : undefined}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && (
        <Oval
          visible={true}
          height="16"
          width="16"
          color="#4c70ef"
          secondaryColor="#FFF"
          ariaLabel="oval-loading"
          strokeWidth="6"
          strokeWidthSecondary="6"
        />
      )}
      {icon}
      {children}
    </button>
  );
};

export default Button;
